/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type RecreateResourceGroupMutationVariables = Types.Exact<{
  resourceId: Types.Scalars['ID']['input'];
}>;


export type RecreateResourceGroupMutation = { __typename: 'Mutation', recreateResourceGroup?: { __typename: 'RecreateResourceGroupMutation', success?: boolean | null, errors?: Array<string | null> | null, resource?: { __typename: 'ResourceType', id: string, isPrimaryResource: boolean, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null } | null } | null };



export const RecreateResourceGroupDocument = `
    mutation RecreateResourceGroup($resourceId: ID!) {
  recreateResourceGroup(resourceId: $resourceId) {
    success
    errors
    resource {
      id
      isPrimaryResource
      resourceGroup {
        id
      }
    }
  }
}
    `;

export const useRecreateResourceGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RecreateResourceGroupMutation, TError, RecreateResourceGroupMutationVariables, TContext>) => {
    
    return useMutation<RecreateResourceGroupMutation, TError, RecreateResourceGroupMutationVariables, TContext>(
      {
    mutationKey: ['RecreateResourceGroup'],
    mutationFn: (variables?: RecreateResourceGroupMutationVariables) => fetcher<RecreateResourceGroupMutation, RecreateResourceGroupMutationVariables>(RecreateResourceGroupDocument, variables)(),
    ...options
  }
    )};


useRecreateResourceGroupMutation.fetcher = (variables: RecreateResourceGroupMutationVariables) => fetcher<RecreateResourceGroupMutation, RecreateResourceGroupMutationVariables>(RecreateResourceGroupDocument, variables);
